import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { FreeDecisionPopupFunnel } from '@lusha/data-in-connector-widgets';
import { PLATFORM } from '@lusha/source-platforms';
import { useAppDispatch, useAppSelector } from '@reducers/index';
import PopupsDispatcher from '@reducers/popups/dispatcher';
import { selectIsUserInFreeDecisionPopup } from '@reducers/user/selectors';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import useFetchAccountCredits from '../../../hooks/useFetchAccountCredits';
import { getLimitType, getLimitTypeByFailedShowMessage } from './utils';
export const FreeTrialDecisionPopup = observer(function FreeTrialDecisionPopup() {
    const dispatch = useAppDispatch();
    const { user, platform, displayByUserAction, displayByCTA, failLimitReason } = useAppSelector(state => (Object.assign({ user: state.user, platform: state.settings.platform }, state.popups.freeTrialDecision)));
    const [shouldDisplayPopup, setShouldDisplayPopup] = useState(false);
    const [displayByLogin, setDisplayByLogin] = useState(false);
    const { outOfCreditsBalance } = useFetchAccountCredits();
    const { isOutOfEmailCredits, isOutOfPhoneCredits } = outOfCreditsBalance;
    useEffect(() => {
        const shouldDisplayBannerWithNoUserActions = selectIsUserInFreeDecisionPopup(user) && (isOutOfEmailCredits || isOutOfPhoneCredits);
        if (shouldDisplayBannerWithNoUserActions) {
            setShouldDisplayPopup(true);
            setDisplayByLogin(true);
        }
    }, [isOutOfEmailCredits, isOutOfPhoneCredits]);
    if (!shouldDisplayPopup && !displayByUserAction) {
        return null;
    }
    const onClosePopup = () => {
        dispatch(PopupsDispatcher.actions.hideFreeTrialDecisionPopup());
        setShouldDisplayPopup(false);
        setDisplayByLogin(false);
    };
    const limitType = displayByUserAction
        ? getLimitTypeByFailedShowMessage(failLimitReason, isOutOfEmailCredits, isOutOfPhoneCredits)
        : getLimitType(isOutOfEmailCredits, isOutOfPhoneCredits);
    const biMetadata = {
        displayByCTA,
        displayByLogin,
    };
    return (_jsx(FreeDecisionPopupFunnel, { variant: PLATFORM.PLUGIN, onClose: onClosePopup, limitType: limitType, product: platform, platform: PLATFORM.PLUGIN, biMetadata: biMetadata, isInFreeTrailDecisionPopupTest: true }));
});
